// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"b857c02b","781":"b857c02b"}[chunkId] + ".chunk.css";
};